import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const defaultOptions = {
  renderText: (text) =>
    text
      .split('\n')
      .reduce(
        (children, textSegment, index) => [
          ...children,
          index > 0 && <br key={index} />,
          textSegment,
        ],
        [],
      ),
};

type DocumentToReactComponents = Parameters<typeof documentToReactComponents>;

export type ContentfulContent = DocumentToReactComponents[0];

export type ContentfulOptions = DocumentToReactComponents[1];

type RichTextRendererProps = {
  content: ContentfulContent;
  options?: ContentfulOptions;
};

const RichTextRenderer = ({
  content,
  options = defaultOptions,
}: RichTextRendererProps) => <>{documentToReactComponents(content, options)}</>;

export default RichTextRenderer;
